import React from "react";
import classnames from "classnames";
import { createStyles } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/core/styles";
import { Checkbox, Typography } from "@material-ui/core";

const styles = (theme) =>
  createStyles({
    templateCard: {
      border: "2px solid #EEEEEE",
      borderRadius: "10px",
      background: "#fff",
      padding: theme.spacing(2),
      cursor: "pointer",
      minHeight: "78.48px",
      display: "flex",
      flexDirection: "column",
      placeContent: "space-around",
      position: "relative",
    },
    activeTemplate: {
      border: "2px solid #4A87F8",
    },
    templateCardAlign: {
      display: "flex",
      alignItems: "center",
      // justifyContent: "space-between",
      // marginBottom: '10px',
      width: "100%",
      "& .checkboxUi": {
        minWidth: "45px",
      },
    },
    templateName: {
      fontSize: theme.spacing(2),
      fontWeight: 400,
    },
    deleteIcon: {
      padding: 4,
      marginLeft: "auto",
      minWidth: "40px",
      textAlign: "right",
      lineHeight: "10px",
      paddingRight: 0,
    },
    templateFlags: {
      display: "flex",
      marginTop: "-12px",
      marginLeft: "-7px",
      "& span": {
        padding: "3px 7px",
        fontSize: "11px",
        textAlign: "left",
        borderRadius: "5px",
        marginRight: "7px",
        opacity: ".8",
        // marginTop: '10px',
        display: "inline-block",
        // position: 'absolute',
        // left: '11px',
        // top: '11px'
      },
      "& .typeE": {
        color: "#155724",
        backgroundColor: "#d4edda",
        borderColor: "#c3e6cb",
      },
      "& .typeR": {
        color: "#721c24",
        backgroundColor: "#f8d7da",
        borderColor: "#f5c6cb",
      },
    },
  });

const TemplateCard = ({
  classes,
  isCheckBox,
  form,
  formId,
  formType,
  selectedForm,
  selectFormFormSurvey,
  type,
  onClick,
  isChooseTemplate=false
}) => (
  <div
    className={classnames(classes.templateCard, {
      [classes.activeTemplate]: formId === form.ID,
    })}
    onClick={() => {
        onClick(
          `/app/settings/templates/forms/${type === 'ORG'? 'custom' : 'default'}/${form.ID}`
        )
    }}
  >
    <div className={classnames(classes.templateCardAlign)}>
      {isCheckBox && (
        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
          className="checkboxUi"
        >
          <Checkbox
            checked={
              selectedForm !== null &&
              selectedForm.formId === form.ID &&
              selectedForm.type === type
            }
            onChange={(event) => {
              selectFormFormSurvey(event.target.checked, form.ID, type);
            }}
          />
        </div>
      )}
      <Typography variant={"h5"} className={classes.templateName}>
        {form.FormTitle}
      </Typography>
    </div>
  </div>
);

export default React.memo(withStyles(styles)(TemplateCard));
